import { render, staticRenderFns } from "./MatchHeader.vue?vue&type=template&id=2fe05b86&scoped=true&"
import script from "./MatchHeader.vue?vue&type=script&lang=js&"
export * from "./MatchHeader.vue?vue&type=script&lang=js&"
import style0 from "./MatchHeader.vue?vue&type=style&index=0&id=2fe05b86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe05b86",
  null
  
)

export default component.exports